/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import { useSelector } from "react-redux";
import BaseSearchField from "./common/BaseSearchField";

import { updateFilters } from "../slices/filtersSlice";
import defaultGoTrackFilters from "../helpers/defaultGoTrackFilters";

const SearchField = () => {
  const searchTerm = useSelector((state) => state.filters.searchTerm);
  const isFetching = useSelector((state) => state.coveredRoutes.isFetching);

  return (
    <BaseSearchField
      searchTerm={searchTerm}
      isFetching={isFetching}
      updateFilters={updateFilters}
      placeholder={"Route code, ID, or trailer #"}
      defaultFilters={defaultGoTrackFilters}
    />
  );
};

export default SearchField;
